import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getReminders, getRemindersSummary, getReminderDetail } from '../api';
import { buildRemindersQueryParams } from '../utils';

export const reminderKeys = {
  all: ['reminders'],
  list: (companyId, params) => ['reminders', companyId, params],
  summary: (companyId, params) => ['reminders-summary', companyId, params],
  detail: (companyId, reminderId) => [
    'reminders-detail',
    companyId,
    reminderId,
  ],
};

export function useReminders(companyId, filters) {
  const params = buildRemindersQueryParams(filters);

  return useQuery({
    queryKey: reminderKeys.list(companyId, params),
    queryFn: () => getReminders(companyId, params),
    enabled: !!companyId,
    placeholderData: keepPreviousData,
  });
}

export function useRemindersSummary(
  companyId,
  { contactId, assignedEmployeeId } = {},
) {
  const summaryParams = {};
  if (contactId) summaryParams.contact_id = contactId;
  if (assignedEmployeeId)
    summaryParams.assigned_employee_id = assignedEmployeeId;

  return useQuery({
    queryKey: reminderKeys.summary(companyId, summaryParams),
    queryFn: () => getRemindersSummary(companyId, summaryParams),
    enabled: !!companyId,
  });
}

export function useReminderDetail(companyId, reminderId) {
  return useQuery({
    queryKey: reminderKeys.detail(companyId, reminderId),
    queryFn: () => getReminderDetail({ companyId, reminderId }),
    enabled: !!companyId && !!reminderId,
  });
}
